import React from 'react';
import { getHomeConfiglList } from 'api/operation';
import { getHomeConfiglList as providerGet } from 'api/provider';
import { HomeConfig } from 'types/common';

let globalData:HomeConfig[] = [];

const useHomeConfig = (isOps?: boolean):[HomeConfig[], boolean, ()=>void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<HomeConfig[]>(globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const fn = isOps ? getHomeConfiglList : providerGet;
            const result = await fn();
            if (!result.error) {
                const data:HomeConfig[] = result?.data?.data || [];
                globalData = data;
                setItems(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!items || items.length === 0) {
            if (!loading) {
                fetchData();
            }
        }
    }, []);

    return [items, loading, fetchData];
};

export default useHomeConfig;
